import React, { createContext, useReducer, useContext, useEffect } from 'react';
import * as api from 'da-pcc-frontend-accountmanagement-api';
import AccountContext from './AccountContext';
import withAPI from '../api';

const Context = createContext<[
  api.AccountNotifications, (update: Partial<api.AccountNotifications>) => void]
>([{}, null]);

/** Reducer */
const reducer = (state: api.AccountNotifications, next: Partial<api.AccountNotifications>) => {
  for (let key in next) {
    if (!next[key])
      next[key] = undefined;
  }

  return {
    ...state,
    ...next
  }
};

/** Retrieve latest account state */
const Producer = () => {
  const [, dispatch ] = useContext(Context);
  const [{ account }] = useContext(AccountContext);

  useEffect(() => {

    // Retrieve notifications for account
    withAPI(api.AccountsApi)
      .getAccountsIdNotifications({ id: account.id })
      .then(
        dispatch,
        console.error
      );

  }, [ account, dispatch ]);

  return null;
}

/** Notification Provider */
const AccountNotificationProvider = ({ children }: { children?: React.ReactNode }) => {
  const value = useReducer(reducer, {} as api.AccountNotifications);

  return (
    <Context.Provider value={value}>
      <Producer />
      {children}
    </Context.Provider>
  )
}

/** Retrieve account notification context */
const useAccountNotifications = () => useContext(Context);

export {
  AccountNotificationProvider,
  useAccountNotifications
}